import React from "react";
import { FormBuilder } from "../../../../components/form/FormBuilder";
import { forms } from "../../../../shared/static/forms";
import { store } from "../../../../redux/store";
import { hideModal } from "../../../../connected-components/modal/reducer";
import { addMedication } from "./actions";
import {
  AddMedicationRequest,
  Medication,
} from "../../../../interfaces/api/medications";

interface AddNewMedicationProps {
  onSuccess?: (medication: Medication) => void;
}

const AddNewMedication: React.FC<AddNewMedicationProps> = ({ onSuccess }) => {
  const handleSubmit = async (value: Record<string, any>) => {
    const response = await addMedication(value as AddMedicationRequest);
    if (response && response.result === "success" && response.content) {
      onSuccess?.(response.content);
      store.dispatch(hideModal());
    }
  };

  return (
    <div className="w-full pt-4">
      <FormBuilder
        schema={forms.addNewMedication}
        gridConfig={{ mobile: 1, desktop: 2 }}
        initialValues={{ is_active: 1 }}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default AddNewMedication;
